import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Label = _resolveComponent("Label")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Label, {
      error: _ctx.error,
      labelId: _ctx.labelId,
      label: _ctx.label
    }, null, 8, ["error", "labelId", "label"]),
    _createVNode("textarea", {
      id: _ctx.labelId,
      class: ["w-full p-2 mt-2 border rounded outline-none", {
				'border-gray-300 focus:border-primary': !_ctx.error,
				'border-red-600': _ctx.error,
			}],
      value: _ctx.value,
      onBlur: _cache[1] || (_cache[1] = $event => (_ctx.updateValue($event.target.value))),
      onInput: _cache[2] || (_cache[2] = $event => (_ctx.updateValue($event.target.value))),
      "aria-labelledby": _ctx.labelId
    }, null, 42, ["id", "value", "aria-labelledby"])
  ]))
}